import { render, staticRenderFns } from "./group-member-info.vue?vue&type=template&id=41650a64&scoped=true"
import script from "./group-member-info.vue?vue&type=script&lang=js"
export * from "./group-member-info.vue?vue&type=script&lang=js"
import style0 from "./group-member-info.vue?vue&type=style&index=0&id=41650a64&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41650a64",
  null
  
)

export default component.exports